// TeamCalendarView.js
import React, { useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useTeamEvents } from './useTeamEvents';
import { Modal, Button } from 'react-bootstrap';

const localizer = momentLocalizer(moment);

const TeamCalendarView = ({ teamId }) => {
  const { events, loading } = useTeamEvents(teamId);
  const [selectedEvent, setSelectedEvent] = useState(null);

  console.log('[Modal Selected Event]', selectedEvent);

  if (loading) return <div>Loading calendar...</div>;

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
  };
  const handleClose = () => setSelectedEvent(null);

  const formatDate = (dateStr) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateStr).toLocaleDateString(undefined, options);
  };

  const formatTime = (dateStr) => {
    return new Date(dateStr).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const projectLinks = {
    1423: 'dEFxZm1QNWNrOElmUU9ZdTltNXUxUT09',
    1424: 'dEFxQ2Z6MlJZUUg2Y0VJQmV2eE1NQT09',
    1425: 'dEFxVlJXQ0RtY2NFUlF2RVVvSUlLdz09',
  };

  return (
    <div style={{ height: '80vh' }}>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        allDayAccessor="allDay"
        titleAccessor={(event) => event.displayTitle || event.title || event.name}
        defaultView="month"
        views={["month", "week", "day"]}
        popup
        selectable
        onSelectEvent={handleSelectEvent}
        eventPropGetter={(event) => ({
          style: {
            fontSize: '0.75rem',
            padding: '2px 4px',
            borderRadius: '4px',
            backgroundColor: event.source === 'calendar_event' ? '#cfe2ff' : '#d1e7dd',
            color: '#000',
            border: '1px solid #999',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          },
        })}
      />

      <Modal show={!!selectedEvent} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedEvent?.displayTitle || selectedEvent?.title || 'Event Details'}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedEvent && (
            <>
              <p><strong>Date:</strong> {formatDate(selectedEvent.start)}</p>

              {!selectedEvent.allDay && (
                <p><strong>Time:</strong> {formatTime(selectedEvent.start)} - {formatTime(selectedEvent.end)}</p>
              )}

              {selectedEvent.location && (
                <p><strong>Location:</strong> {selectedEvent.location}</p>
              )}

              <p><strong>Organizer:</strong> {selectedEvent.createdBy || 'Unknown'}</p>

              <p>
                <strong>Type:</strong>{' '}
                {selectedEvent.source === 'calendar_event'
                  ? '📤 Shared with calendars'
                  : '🗒️ Internal team event'}
                {' '}
                {selectedEvent.source === 'calendar_event' && (
                  <span className="badge bg-success">Calendar Invite Sent</span>
                )}
              </p>

              {selectedEvent.source === 'calendar_event' && selectedEvent.attendees?.length > 0 && (
                <div>
                  <strong>Participants:</strong>
                  <div style={{
                    maxHeight: '120px',
                    overflowY: selectedEvent.attendees.length > 4 ? 'auto' : 'visible',
                    border: '1px solid #ccc',
                    padding: '6px',
                    marginTop: '6px',
                    borderRadius: '4px',
                    background: '#f8f9fa'
                  }}>
                    <ul className="mb-0 ps-3">
                      {selectedEvent.attendees.map((email, idx) => (
                        <li key={idx}>{email}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer className="justify-content-between">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {selectedEvent?.projectCategoryId && (
            <a
              href={`http://zynity_yii.test/highlights/index/?category_id=${selectedEvent.projectCategoryId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              View Original Item
            </a>
          )}
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default TeamCalendarView;
